import * as Yup from "yup";
import { validationErrors } from "./validationRules.js";
import validationUtils from "./ValidationUtils.js";

const changePasswordSchema = Yup.object().shape({
  current_password: Yup.string().required(
    validationErrors?.getRequiredField("current password")
  ),
  new_password: validationUtils
    ?.validatePassword({ fieldName: "new password" })
    .test(
      "not-same-as-old",
      validationErrors?.password?.sameAsOld,
      function (value) {
        // Only check if different from old password when both fields have values
        return (
          !value ||
          !this?.parent?.current_password ||
          this?.parent?.current_password !== value
        );
      }
    ),
  new_password_confirm: Yup.string()
    .required(validationErrors?.getRequiredField("confirm password"))
    .test(
      "passwords-match",
      validationErrors?.password?.notMatch,
      function (value) {
        // Only check match if both fields have values
        return !value || this?.parent?.new_password === value;
      }
    ),
});

export default changePasswordSchema;
